/**
 * Licensed Materials - Property of IBM
 * IBM Watson (C) Copyright IBM Corp. 2018
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import RecommendedCommon from '../RecommendedCommon';

import './relatedInsights.scss';

class RelatedInsights extends Component {
	constructor(props) {
		super(props);
	}

	render() {
		return (
			<RecommendedCommon
				{...this.props}
				className="vis-related-insights"
				enableSeeMore={true}
				maxDisplayedItems={3}
				logger={this.props.logger}
			/>
		);
	}
}

RelatedInsights.propTypes = {
	dashboardApi: PropTypes.object.isRequired,
	onClickItem: PropTypes.func,
	recommendationVM: PropTypes.object.isRequired,
	additionalProperties: PropTypes.arrayOf(PropTypes.object),
	logger: PropTypes.object
};
RelatedInsights.defaultProps = {
	onClickItem: () => {},
	additionalProperties: []
};
export default RelatedInsights;



// WEBPACK FOOTER //
// ./src/js/lib/@waca/vis-recommender/src/js/related/RelatedInsights.js